<template>
  <div v-if="isSuccess" class="bg-white p-12 shadow-md">
    <h2>Neues Dokument</h2>
    <FormKit type="form" @submit="handleSubmit">
      <FormKit validation="required" type="text" label="Name" name="name"></FormKit>
      <FormKit
        validation="required"
        type="select"
        name="templateId"
        label="Template"
        :options="
          templates!.map(template => {
            return { value: template.id, label: template.name }
          })
        "
      ></FormKit>
    </FormKit>
  </div>
</template>

<script setup lang="ts">
import { errorNotification, successNotification } from '@/utils/notifications'
import { createDocument } from '@/services/documentsService'
import { useRouter } from 'vue-router'
import { getTemplates } from '@/admin/services/template-service'
import { useQuery } from '@tanstack/vue-query'
const router = useRouter()

const { data: templates, isSuccess } = useQuery({
  queryKey: ['templates'],
  queryFn: getTemplates,
})

const handleSubmit = async (data: { name: string; templateId: string }) => {
  const document = await createDocument(data.name, data.templateId)
    .then(document => {
      successNotification()
      return document
    })
    .catch(error => {
      errorNotification(error?.response?.data?.error)
      return null
    })

  if (!document) {
    return
  }

  const target = { name: 'questionnaire', params: { documentId: document.id } }
  router.push(target)
}
</script>
